import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 12 19" {...props}>
      <title>{props.title || 'Carousel-Arrow-Right'}</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.585786 0.585786C1.36683 -0.195262 2.63317 -0.195262 3.41421 0.585786L10.9142 8.08579C11.6953 8.86684 11.6953 10.1332 10.9142 10.9142L3.41421 18.4142C2.63317 19.1953 1.36683 19.1953 0.585786 18.4142C-0.195262 17.6332 -0.195262 16.3668 0.585786 15.5858L6.67157 9.5L0.585786 3.41421C-0.195262 2.63317 -0.195262 1.36683 0.585786 0.585786Z"
          fill="white"
        />
      </g>
    </Icon>
  )
}
